import { render, staticRenderFns } from "./EthnicityManagement.vue?vue&type=template&id=532f5e00&scoped=true&"
import script from "./EthnicityManagement.vue?vue&type=script&lang=js&"
export * from "./EthnicityManagement.vue?vue&type=script&lang=js&"
import style0 from "./EthnicityManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EthnicityManagement.vue?vue&type=style&index=1&id=532f5e00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f5e00",
  null
  
)

export default component.exports